import React, { useState, useEffect, useRef } from "react";
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  IconButton,
  Button, 
  Divider,
  TextField,
  Typography,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Snackbar,
  Grid,
  Box
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import FacebookIcon from '@mui/icons-material/Facebook';
import { useUserAuth } from '../context/UserAuthContext'
import { GET_CLIENT_SERVICE } from '../services/userService'

import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import { useNavigate } from 'react-router-dom';


const MenuCarruselPopup = ({ open, onClose, title, code }) => {
    const { user, changeAddress } = useUserAuth();
    const [foundAddress, setFoundAddress] = useState(null); 
  const navigate = useNavigate();
  const [isEditing, setIsEditing] = useState(false);
  const [tempPhone, setTempPhone] = useState(user?.phoneEmergency || "106");
  const [showSnackbar, setShowSnackbar] = useState(false);


  const [g_precioVenta, g_setPrecioVenta] = useState('');
  const [g_costo, g_setCosto] = useState('');

  const g_calcular = () => {
    const pv = parseFloat(g_precioVenta) || 0;
    const c = parseFloat(g_costo) || 0;
    const g_Soles =  c > 0 && pv > 0 ? (pv - c) : 0;
    const g_Porcentaje = c > 0 && pv > 0 ? ((g_Soles * 100) / pv ) : 0;
    return {
      g_soles: g_Soles.toFixed(1),
      g_porcentaje: g_Porcentaje.toFixed(1)
    };
  };
  const { g_soles, g_porcentaje } = g_calcular();


  const [a_ganancia, a_setGanancia] = useState('');
  const [a_costo, a_setCosto] = useState('');
  const a_calcular = () => {
    const g = parseFloat(a_ganancia) || 0;
    const c = parseFloat(a_costo) || 0;
    const a_gananciaSoles =  c > 0 && g > 0 ? (g * c / (100 - g)) : 0;
    const a_precioventa = c > 0 && g > 0 ? (c * 100 / (100 - g)) : 0;
    return {
      a_gananciaSoles: a_gananciaSoles.toFixed(1),
      a_precioventa: a_precioventa.toFixed(1)
    };
  };
  const { a_gananciaSoles, a_precioventa } = a_calcular();

    useEffect(() => {  
  if (open) {
    if (code == "CASERITOS")
    {
      navigate('/tienda/Caseritos');
    }
    else if (code == "HISTORIA")
    {
      window.location.href = '/tienda/mihistoria/index.html';
    }
     g_setPrecioVenta(""); // Limpia al abrir
     g_setCosto("");
     a_setGanancia(""); // Limpia al abrir
     a_setCosto("");
     setIsEditing(false);

     const fetchData = async () => {
        const { data } = await GET_CLIENT_SERVICE(user);
         let address;
        if (user.addressId == null) {
          address = newUser.deliveryAddresses?.[0]?.Contact; // Optional chaining por seguridad
        } else {
          const dir = user?.deliveryAddresses?.find(addr => addr.addressId === user.addressId);
          address = dir.Contact
        }

        setFoundAddress(address); // Guarda en el estado

        console.log('newUserMERG', address);
      }
      fetchData()

  }
}, [open]); // Se ejecuta cuando `open` cambia

  const getColorByPercentage = (percentage, a, b) => {
    if (b === '' || a === '' || percentage === '') return '';
  const value = parseFloat(percentage) || 0;
  if (value < 10) return '#000000';      // Negro 😡
  if (value < 15) return '#EE0000';    // Rojo 😠
  if (value < 20) return '#FF6699';         // Naranja 🤨
  if (value < 25) return '#0070C0';       // Azul 😌
  if (value >= 25) return '#00B050';       // Verde 😄
  return '#000000';   // Verde  *
};

// Función para obtener el emoji correspondiente
const getEmojiByPercentage = (percentage, a, b) => {
  // console.log('percentage', percentage);
  // console.log('a', a);
  // console.log('b', b);
   if (b === '' || a === '' || percentage === '') return '';
  const value = parseFloat(percentage) || 0;
  if (value < 10) return '😡';
  if (value < 15) return '😠';
  if (value < 20) return '🤨';
  if (value < 25) return '😌';
  if (value >= 25) return '😄';
  return '';
};

const handleEditClick = () => {
    setTempPhone(user?.phoneEmergency || "106"); // Reset al valor original
    setIsEditing(true);
  };

 const handleSave = async () => {

  const traceData = {
      clientCode: user.clientCode,
      phoneEmergency: tempPhone
    };
  console.log("trace:", traceData);
    try {
      const response = await fetch(process.env.REACT_APP_GET_USER_PHONEEMERGENCY_UPDATE_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(traceData),
      });
  
       user.phoneEmergency = tempPhone; // Actualiza el número de teléfono en el usuario
      setShowSnackbar(true);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
    } catch (error) {
      console.error("Error al guardar:", error);
      // Revertir el cambio si falla
      setTempPhone(user.phoneEmergency || "106");
    }
  finally {
      setIsEditing(false);
    }

  };


  const handleCancel = () => {
    setIsEditing(false);
  };
  

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth
     PaperProps={{
    sx: {
      // Estilos para web (tamaño fijo)
      '@media (min-width: 600px)': {  // Breakpoint para dispositivos no móviles
        maxHeight: '80%',
        minHeight: '700px',
        height: 'auto'
      },
      // Estilos para móvil (pantalla completa)
      '@media (max-width: 599px)': {  // Breakpoint para móviles
        height: '100%', // Usa viewport height para asegurar 100% de altura
        width: '100vw',  // Usa viewport width para asegurar 100% de ancho
        maxHeight: '100%', // Anula cualquier maxHeight previo
        margin: 0,
        borderRadius: 0,
        // Opcional: asegura que el contenido interior también se expanda
        '& .MuiDialog-container': {
          alignItems: 'flex-start'
        }
      }
    }
  }}
      >
      <DialogTitle style={{ textAlign: "center", fontWeight: "bold" }}>
        {title}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: code === 'CALCULADORA' ? 'block' : 'none' }}>
          <Box>
            <Typography 
                sx={{ 
                   mb: 1, 
                  fontSize: '18px',
                  fontWeight: 'bold',
                  textAlign: 'center',
                  color: 'black'
                }}
              >
                ¡Calcula tu ganancia ahora!
              </Typography>
               <Typography 
                sx={{ 
                  mb: 1, 
                  fontSize: '14px',
                  textAlign: 'left',
                  color: 'black'
                }}
              >
                Ingresa tu precio de venta y costo
              </Typography>

            <Grid container spacing={1}>
              <Grid item xs={6} md={6}>
                <TextField
                    fullWidth
                     size="small"
                    label="Precio venta (S/)"
                    variant="outlined"
                    type="number"
                    inputProps={{ step: "0.1", min: "0" }}
                    value={g_precioVenta}
                    onChange={(e) => g_setPrecioVenta(e.target.value)}
                    onBlur={(e) => {
                      if (e.target.value !== '') {
                        g_setPrecioVenta(parseFloat(e.target.value).toFixed(1));
                      }
                    }}
                  />
              </Grid>
              <Grid item xs={6} md={6}>
                <TextField
                    fullWidth
                    size="small"
                    label="Costo (S/)"
                    variant="outlined"
                    type="number"
                    inputProps={{ step: "0.1", min: "0" }}
                    value={g_costo}
                    onChange={(e) => g_setCosto(e.target.value)}
                    onBlur={(e) => {
                      if (e.target.value !== '') {
                        g_setCosto(parseFloat(e.target.value).toFixed(1));
                      }
                    }}
                  />
              </Grid>

              <Grid item xs={12}>
                <Box sx={{ 
                  backgroundColor: '#f8f9fa', 
                  borderRadius: 1, 
                  p: 2,
                  borderLeft: `4px solid ${getColorByPercentage(g_porcentaje, g_precioVenta, g_costo)}`
                }}>
                  <Grid container spacing={1}>
                    <Grid item xs={6}>
                      <Typography>Ganancia %:</Typography>
                      <Typography variant="h6" color={getColorByPercentage(g_porcentaje, g_precioVenta, g_costo)}>{g_porcentaje}%</Typography>

                    </Grid>
                    <Grid item xs={6}>
                      <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Box>
                          <Typography>Ganancia S/:</Typography>
                          <Typography variant="h6" color={getColorByPercentage(g_porcentaje, g_precioVenta, g_costo)}> S/ {g_soles} </Typography>
                        </Box>
                        <Typography variant="h5" sx={{ ml: 1 }}> {getEmojiByPercentage(g_porcentaje, g_precioVenta, g_costo)}</Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Box>

          <Box 
                sx={{ height: '20px',display: 'flex',alignItems: 'center',
                  '&::before': {
                    content: '""',
                    flex: 1,
                    borderBottom: '1px solid gray'
                  }
                }}
              />

          <Box>
            <Typography 
                sx={{ 
                  mb: 1, 
                  fontSize: '18px',
                  fontWeight: 'bold',
                  textAlign: 'center',
                  color: 'black'
                }}
              >
                ¿A qué precio vender?
              </Typography>
               <Typography 
                sx={{ 
                  mb: 1, 
                   fontSize: '14px',
                  textAlign: 'left',
                  color: 'black'
                }}
              >
               Ingresa cuánto quieres ganar y costo
              </Typography>

            <Grid container spacing={1}>
              
              <Grid item xs={6} md={6}>
                <TextField
                    fullWidth
                    size="small"
                    label="Ganancia (%)"
                    variant="outlined"
                    type="number"
                    inputProps={{ step: "0.1", min: "0" , max: "100" }}
                    value={a_ganancia}
                    onChange={(e) => a_setGanancia(e.target.value)}
                    onBlur={(e) => {
                      if (e.target.value !== '') {
                        const parsedValue = Math.min(100, parseFloat(e.target.value)); // 👈 Fuerza máximo 100
                        a_setGanancia(parsedValue.toFixed(1));
                      }
                    }}
                  />
              </Grid>
              <Grid item xs={6} md={6}>
                <TextField
                    fullWidth
                    size="small"
                    label="Costo (S/)"
                    variant="outlined"
                    type="number"
                    inputProps={{ step: "0.1", min: "0" }}
                    value={a_costo}
                    onChange={(e) => a_setCosto(e.target.value)}
                    onBlur={(e) => {
                      if (e.target.value !== '') {
                        a_setCosto(parseFloat(e.target.value).toFixed(1));
                      }
                    }}
                  />
              </Grid>

              <Grid item xs={12}>
                <Box sx={{ 
                  backgroundColor: '#f8f9fa', 
                  borderRadius: 1, 
                  p: 2,
                  borderLeft: `4px solid ${getColorByPercentage(a_ganancia, a_ganancia, a_costo)}`
                }}>
                  <Grid container spacing={1}>
                    <Grid item xs={6}>
                      <Typography>P. venta S/:</Typography>
                      <Typography variant="h6" color={getColorByPercentage(a_ganancia, a_ganancia, a_costo)}>S/ {a_precioventa}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Box>
                          <Typography>Ganancia S/:</Typography>
                          <Typography variant="h6" color={getColorByPercentage(a_ganancia, a_ganancia, a_costo)}> S/ {a_gananciaSoles} </Typography>
                        </Box>
                        <Typography variant="h5" sx={{ ml: 1 }}> {getEmojiByPercentage(a_ganancia, a_ganancia, a_costo)}</Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Box>

              <Box 
                sx={{ height: '20px',display: 'flex',alignItems: 'center',
                  '&::before': {
                    content: '""',
                    flex: 1,
                    borderBottom: '1px solid gray'
                  }
                }}
              />

              <Typography 
                variant="subtitle1" 
                sx={{ 
                  fontWeight: 'bold',
                  textAlign: 'left',
                  color: 'black'
                }}
              >
                Opinión de bodegueros
              </Typography>
              
<TableContainer component={Paper}>
  <Table size="small">
    <TableBody>
      <TableRow>
        <TableCell sx={{ 
          bgcolor: 'black', 
          color: '#FFFFFF',
          fontWeight: 'bold'
        }}>
          Menos de 10%
        </TableCell>
        <TableCell>No rentable</TableCell>
        <TableCell>😡</TableCell>
      </TableRow>
      
      <TableRow>
        <TableCell sx={{ 
          bgcolor: '#EE0000', 
          color: '#FFFFFF',
          fontWeight: 'bold'
        }}>
          10% - 15%
        </TableCell>
        <TableCell>Muy bajo</TableCell>
        <TableCell>😠</TableCell>
      </TableRow>
      
      <TableRow>
        <TableCell sx={{ 
          bgcolor: '#FF6699', 
          color: '#FFFFFF',
          fontWeight: 'bold'
        }}>
          15% - 20%
        </TableCell>
        <TableCell>Regular</TableCell>
        <TableCell>🤨</TableCell>
      </TableRow>
      
      <TableRow>
        <TableCell sx={{ 
          bgcolor: '#0070C0', 
          color: '#FFFFFF',
          fontWeight: 'bold'
        }}>
          20% - 25%
        </TableCell>
        <TableCell>Bueno</TableCell>
        <TableCell>😌</TableCell>
      </TableRow>
      
      <TableRow>
        <TableCell sx={{ 
          bgcolor: '#00B050', 
          color: '#FFFFFF',
          fontWeight: 'bold'
        }}>
          Más de 25%
        </TableCell>
        <TableCell>Muy bueno</TableCell>
        <TableCell>😄</TableCell>
      </TableRow>
    </TableBody>
  </Table>
</TableContainer>

          <Typography 
                sx={{ 
                  fontSize: '14px',
                  textAlign: 'left',
                  color: 'black'
                }}
              >
                La clasificación puede variar según rotación y competencia
              </Typography>
        </Box>
        <Box sx={{ display: code === 'AYUDA' ? 'block' : 'none' }}>

            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, alignSelf: 'flex-start' }}>
               <Typography sx={{ mb: 1, fontSize: '25px',textAlign: 'left',color: 'black'}}>
                🤝
              </Typography>
               <Typography sx={{ mb: 1, fontSize: '18px', fontWeight: 'bold',  textAlign: 'left', color: 'black' }}>
                La Comunidad Bodeguera Responde
              </Typography>
            </Box>

               <Typography 
                sx={{ 
                  mb: 1, 
                  fontSize: '14px',
                  textAlign: 'left',
                  color: 'black'
                }}
              >
                ¿No sabes a qué precio vender? ¡No estás solo!  únete al grupo Bodegueros y Minimarkets Peruanos Unidos, donde más de 10,000 bodegueros como tú ya están ayudándose.
              </Typography>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
               <Typography sx={{ mb: 1, fontSize: '25px',textAlign: 'left',color: 'black'}}>
                🔗 
              </Typography>
              <Typography sx={{ mb: 1, fontSize: '14px',textAlign: 'left',color: 'black'}}>
                ¿Qué pasa cuando presionas "Ir al Grupo"?
              </Typography>
            </Box>

              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
               <Typography sx={{ mb: 1, fontSize: '25px',textAlign: 'left',color: 'black'}}>
                1️⃣ 
              </Typography>
              <Typography sx={{ mb: 1, fontSize: '14px',textAlign: 'left',color: 'black'}}>
                Serás redirigido a nuestra comunidad privada y segura en Facebook.
              </Typography>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
               <Typography sx={{ mb: 1, fontSize: '25px',textAlign: 'left',color: 'black'}}>
                2️⃣
              </Typography>
              <Typography sx={{ mb: 1, fontSize: '14px',textAlign: 'left',color: 'black'}}>
                Haz tu pregunta (ej: ¿Gente(amigos, colegas) a cómo venden el arroz 5kg?). 
              </Typography>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
               <Typography sx={{ mb: 1, fontSize: '25px',textAlign: 'left',color: 'black'}}>
                3️⃣
              </Typography>
              <Typography sx={{ mb: 1, fontSize: '14px',textAlign: 'left',color: 'black'}}>
                ¡Recibe respuestas de colegas en tiempo real!
              </Typography>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
               <Typography sx={{ mb: 1, fontSize: '25px',textAlign: 'left',color: 'black'}}>
                👉
              </Typography>
              <Typography sx={{ fontSize: '14px', color: 'black' }}>
                  ¡No adivines, conéctate!{' '}
                  <Link
                    href="https://www.facebook.com/groups/989156445030808/?ref=share&mibextid=NSMWBT"
                    sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FacebookIcon fontSize="small" />
                    ¡IR AL GRUPO AHORA!
                  </Link>

                </Typography>
            </Box>

          </Box>
         <Box sx={{ display: code === 'EMERGENCIA' ? 'block' : 'none' }}>

            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, alignSelf: 'flex-start' }}>
               {/* <Typography sx={{ mb: 1, fontSize: '25px',textAlign: 'left',color: 'black'}}>
                🤝
              </Typography> */}
               <Typography sx={{ mb: 1, fontSize: '18px', fontWeight: 'bold',  textAlign: 'left', color: 'black' }}>
                ¡Actúa Rápido, Estamos Contigo y tu familia!
              </Typography>
            </Box>

               <Typography 
                sx={{ 
                  mb: 1, 
                  fontSize: '14px',
                  textAlign: 'left',
                  color: 'black'
                }}
              >
                En caso de emergencia, marca directamente desde vedoraplus presionando los botones a continuación. 
              </Typography>

            <Box sx={{ 
              width: '100%', // Puedes ajustar este valor según necesites
              maxWidth: '100%', // Para que no exceda el ancho disponible
              margin: '0 auto', // Centrar el contenedor principal
              padding: 0.5 // Añadir un poco de padding
            }}>
              <Grid container spacing={0.5}>
                {/* Primera fila con dos columnas */}
                <Grid item xs={6} sm={6}>
                  <Box 
                  component="a"
                    href={`tel:${foundAddress?.ContactoBomberos || '101'}`}
                    sx={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      gap: 1, 
                      height: '100%',
                      textDecoration: 'none', // Elimina el subrayado del enlace
                      cursor: 'pointer', // Cambia el cursor a mano al pasar el mouse
                      '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)', // Efecto hover sutil
                        borderRadius: '4px'
                      },
                      p: 1 // Añade un poco de padding para mejor tacto
                    }}
                  >
                    <Box sx={{
                      width: { xs: '40px', sm: '50px', md: '60px' },
                      height: { xs: '40px', sm: '50px', md: '60px' },
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      <img src="/assets/Bomberos.png" alt="Bomberos" style={{ width: '100%', height: '100%', objectFit: 'contain'}}/>
                    </Box>
                    <Typography sx={{ fontSize: { xs: '16px', sm: '18px', md: '20px' }, fontWeight: 'bold', textAlign: 'left', color: 'black', lineHeight: 1.2}}>
                      Bomberos
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={6} sm={6}>
                   <Box 
                  component="a"
                    href={`tel:${foundAddress?.ContactoPolicia || '102'}`}
                    sx={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      gap: 1, 
                      height: '100%',
                      textDecoration: 'none', // Elimina el subrayado del enlace
                      cursor: 'pointer', // Cambia el cursor a mano al pasar el mouse
                      '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)', // Efecto hover sutil
                        borderRadius: '4px'
                      },
                      p: 1 // Añade un poco de padding para mejor tacto
                    }}
                  >
                    <Box sx={{
                      width: { xs: '40px', sm: '50px', md: '60px' },
                      height: { xs: '40px', sm: '50px', md: '60px' },
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      <img src="/assets/Policia.png" alt="Policía" style={{ width: '100%', height: '100%', objectFit: 'contain'}}/>
                    </Box>
                    <Typography sx={{ fontSize: { xs: '16px', sm: '18px', md: '20px' }, fontWeight: 'bold', textAlign: 'left', color: 'black', lineHeight: 1.2}}>
                      Policía
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={6} sm={6}>
                   <Box 
                  component="a"
                     href={`tel:${foundAddress?.ContactoSerenazgo || '103'}`}
                    sx={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      gap: 1, 
                      height: '100%',
                      textDecoration: 'none', // Elimina el subrayado del enlace
                      cursor: 'pointer', // Cambia el cursor a mano al pasar el mouse
                      '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)', // Efecto hover sutil
                        borderRadius: '4px'
                      },
                      p: 1 // Añade un poco de padding para mejor tacto
                    }}
                  >
                    <Box sx={{
                      width: { xs: '40px', sm: '50px', md: '60px' },
                      height: { xs: '40px', sm: '50px', md: '60px' },
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      <img src="/assets/Serenazgo.png" alt="Serenazgo" style={{ width: '100%', height: '100%', objectFit: 'contain'}}/>
                    </Box>
                    <Typography sx={{ fontSize: { xs: '16px', sm: '18px', md: '20px' }, fontWeight: 'bold', textAlign: 'left', color: 'black', lineHeight: 1.2}}>
                      Serenazgo                                      
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={6} sm={6}>
                   <Box 
                  component="a"
                    href={`tel:${foundAddress?.ContactoExtorsion || '104'}`}
                    sx={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      gap: 1, 
                      height: '100%',
                      textDecoration: 'none', // Elimina el subrayado del enlace
                      cursor: 'pointer', // Cambia el cursor a mano al pasar el mouse
                      '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)', // Efecto hover sutil
                        borderRadius: '4px'
                      },
                      p: 1 // Añade un poco de padding para mejor tacto
                    }}
                  >
                    <Box sx={{
                      width: { xs: '40px', sm: '50px', md: '60px' },
                      height: { xs: '40px', sm: '50px', md: '60px' },
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      <img src="/assets/Extorsion.png" alt="Extorsión" style={{ width: '100%', height: '100%', objectFit: 'contain'}}/>
                    </Box>
                    <Typography sx={{ fontSize: { xs: '16px', sm: '18px', md: '20px' }, fontWeight: 'bold', textAlign: 'left', color: 'black', lineHeight: 1.2}}>
                      Extorsión                                      
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={6} sm={6}>
                  <Box 
                  component="a"
                    href={`tel:${foundAddress?.ContactoAmbulancia || '105'}`}
                    sx={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      gap: 1, 
                      height: '100%',
                      textDecoration: 'none', // Elimina el subrayado del enlace
                      cursor: 'pointer', // Cambia el cursor a mano al pasar el mouse
                      '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)', // Efecto hover sutil
                        borderRadius: '4px'
                      },
                      p: 1 // Añade un poco de padding para mejor tacto
                    }}
                  >
                    <Box sx={{
                      width: { xs: '40px', sm: '50px', md: '60px' },
                      height: { xs: '40px', sm: '50px', md: '60px' },
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      <img src="/assets/Ambulancia.png" alt="Ambulancia" style={{ width: '100%', height: '100%', objectFit: 'contain'}}/>
                    </Box>
                    <Typography sx={{ fontSize: { xs: '16px', sm: '18px', md: '20px' }, fontWeight: 'bold', textAlign: 'left', color: 'black', lineHeight: 1.2}}>
                      Ambulancia                                   
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={6} sm={6}>
                  
                </Grid>
                

                <Grid item xs={12} sm={12}>
                  {!isEditing ? (
                    <Box 
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        height: "100%",
                      }}
                      >
                    <Box
                      component="a"
                      href={`tel:${user?.phoneEmergency || "106"}`}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        height: "100%",
                        textDecoration: "none",
                        cursor: "pointer",
                        "&:hover": {
                          backgroundColor: "rgba(0, 0, 0, 0.04)",
                          borderRadius: "4px",
                        },
                        p: 1,
                      }}
                    >
                      <Box
                        sx={{
                          width: { xs: "40px", sm: "50px", md: "60px" },
                          height: { xs: "40px", sm: "50px", md: "60px" },
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          src="/assets/Colegas.png"
                          alt="Colegas"
                          style={{ width: "100%", height: "100%", objectFit: "contain" }}
                        />
                      </Box>
                      <Typography
                        sx={{
                          fontSize: { xs: "16px", sm: "18px", md: "20px" },
                          fontWeight: "bold",
                          textAlign: "left",
                          color: "black",
                          lineHeight: 1.2,
                        }}
                      >
                        Familiar de Emergencia
                      </Typography>
                    </Box>
                    <Box>
                    <IconButton onClick={handleEditClick} sx={{ ml: "auto", fontSize: { xs: 'large', md: 'large' }, }}>
                        <EditIcon />
                      </IconButton>
                    </Box>
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0,
                        p: 0,
                        backgroundColor: "rgba(0, 0, 0, 0.02)",
                        borderRadius: "4px",
                      }}
                    >
                      <TextField
                        type="tel"
                        value={tempPhone}
                        onChange={(e) => setTempPhone(e.target.value)}
                        label="Nuevo número"
                        variant="outlined"
                        fullWidth
                      />
                      <IconButton onClick={handleSave} color="primary">
                        <SaveIcon />
                      </IconButton>
                      <IconButton onClick={handleCancel} color="error">
                        <CancelIcon />
                      </IconButton>
                    </Box>
                  )}

                  <Snackbar
                    open={showSnackbar}
                    autoHideDuration={3000}
                    onClose={() => setShowSnackbar(false)}
                    message="Contacto guardado correctamente"
                  />
                </Grid>

              </Grid>
            </Box>

          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, alignSelf: 'flex-start' }}>
               {/* <Typography sx={{ mb: 1, fontSize: '25px',textAlign: 'left',color: 'black'}}>
                🤝
              </Typography> */}
               <Typography sx={{ mb: 1, fontSize: '18px', fontWeight: 'bold',  textAlign: 'left', color: 'black' }}>
                ¿Qué hacer?
              </Typography>
            </Box>

              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
               <Typography sx={{ mb: 0, fontSize: '18px',textAlign: 'left',color: 'black'}}>
                1️⃣ 
              </Typography>
              <Typography sx={{ mb: 0, fontSize: '14px',textAlign: 'left',color: 'black'}}>
                Mantén la calma.
              </Typography>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
               <Typography sx={{ mb: 0, fontSize: '18px',textAlign: 'left',color: 'black'}}>
                2️⃣
              </Typography>
              <Typography sx={{ mb: 0, fontSize: '14px',textAlign: 'left',color: 'black'}}>
                Explica tu ubicación y situación con claridad.
              </Typography>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
               <Typography sx={{ mb: 0, fontSize: '18px',textAlign: 'left',color: 'black'}}>
                3️⃣
              </Typography>
              <Typography sx={{ mb: 0, fontSize: '14px',textAlign: 'left',color: 'black'}}>
                Si es seguro, espera en el lugar hasta que llegue la ayuda.
              </Typography>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
               <Typography sx={{ mb: 1, fontSize: '22px',textAlign: 'left',color: 'black'}}>
                🛟
              </Typography>
              <Typography sx={{ mb: 1, fontSize: '16px',  fontWeight: 'bold', textAlign: 'left',color: 'black'}}>
                Tu seguridad y la de tu familia es primero. 
              </Typography>
             
            </Box>


            

          </Box>
      </DialogContent>
      <DialogActions>
        <IconButton
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
      </DialogActions>
    </Dialog>
  );
};

export default MenuCarruselPopup;